import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 md:grid md:grid-cols-2 md:gap-6" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-red-lp-100 py-2 text-12px" }, "Download csv", -1)
const _hoisted_3 = { class: "text-black-lp-200 py-2 text-12px xxl:text-14px font-semibold" }
const _hoisted_4 = { class: "flex flex-row items-center justify-between" }
const _hoisted_5 = { class: "text-gray-lp-300 py-2 text-12px" }
const _hoisted_6 = /*#__PURE__*/_createVNode("path", {
  fill: "#A7A8AA",
  "fill-rule": "evenodd",
  d: "M12 3c.552 0 1 .448 1 1v9.586l2.293-2.293c.39-.39 1.024-.39 1.414 0 .39.39.39 1.024 0 1.414l-4 4c-.39.39-1.024.39-1.414 0l-4-4c-.39-.39-.39-1.024 0-1.414.39-.39 1.024-.39 1.414 0L11 13.586V4c0-.552.448-1 1-1zM4 15c.552 0 1 .448 1 1v1c0 .53.21 1.04.586 1.414C5.96 18.79 6.47 19 7 19h10c.53 0 1.04-.21 1.414-.586C18.79 18.04 19 17.53 19 17v-1c0-.552.448-1 1-1s1 .448 1 1v1c0 1.06-.421 2.078-1.172 2.828C19.078 20.578 18.061 21 17 21H7c-1.06 0-2.078-.421-2.828-1.172C3.422 19.078 3 18.061 3 17v-1c0-.552.448-1 1-1z",
  "clip-rule": "evenodd"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    "display-back": false,
    scrollSidebar: "",
    noSpaceHeader: ""
  }, {
    data: _withCtx(() => [
      _createVNode(_component_Search, {
        onInput: _ctx.onSearch,
        onClear: _ctx.onClearSearch,
        value: _ctx.searchValue,
        placeholder: "Cari berkas",
        class: "w-full"
      }, null, 8, ["onInput", "onClear", "value"]),
      _createVNode("div", _hoisted_1, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredStepFillTemplate, (e, i) => {
          return _withDirectives((_openBlock(), _createBlock("div", {
            key: i,
            class: "py-2 px-4 rounded-md border border-gray-lp-400"
          }, [
            _hoisted_2,
            _createVNode("div", _hoisted_3, _toDisplayString(e.title), 1),
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, _toDisplayString(e.description), 1),
              (_openBlock(), _createBlock("svg", {
                class: "w-5 ml-4 cursor-pointer",
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                onClick: ($event: any) => (_ctx.downloadExisting(e.service, e.type, e.title))
              }, [
                _hoisted_6
              ], 8, ["onClick"]))
            ])
          ], 512)), [
            [_vShow, e.featureFlag]
          ])
        }), 128))
      ])
    ]),
    "sub-data": _withCtx(() => [
      _createVNode("div", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tempList, (e, i) => {
          return _withDirectives((_openBlock(), _createBlock("ul", {
            key: i,
            class: "list-dash px-4"
          }, [
            _createVNode("li", {
              onClick: ($event: any) => (_ctx.downloadExisting(e.service, e.type, e.title)),
              class: "text-red-lp-100 text-13px my-2 cursor-pointer"
            }, _toDisplayString(e.description), 9, ["onClick"])
          ], 512)), [
            [_vShow, e.featureFlag]
          ])
        }), 128))
      ])
    ]),
    _: 1
  }))
}